
import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router';

import { ModalContent, ModalActions } from '@vromo/ui/components/Modal';
import { IntegrationsConfig, Platform } from '@vromo/models';
import Button from '@vromo/ui/components/Button';
import { useIntegrationsActions, useIntegrationsNav, useIntegrationsPage } from '../../hooks';
import { TrayConfigIframe } from '../../components';




/** modal to created / add a new integration */
export const SquareConfigure = observer(() => {

    const {
        finishIntegrationConfig, createIntegrationProfile, cancelIntegrationConfig, fetchIntegrations,
    } = useIntegrationsActions()
    const { isLoading, fetched, fetchedIntegrations } = useIntegrationsPage()
    const { closeModal } = useIntegrationsNav({ modalOpened: true })
    const { platform } = useParams<{ platform: Platform }>()
    const instance = fetchedIntegrations.get(platform)
    const [configCompleted, setConfigCompleted] = useState(false)
    const { features: { iframe = false } = {} } = IntegrationsConfig[platform] ?? {}



    const actionText = useMemo(() => ({
        discard: instance?.completed ?
            "discard changes" :
            "discard creation",
        save: "done"
    }), [instance])


    // fetch or create integration if required. Fetch config wizard url
    useEffect(() => {
        if (
            /* (!instance && fetched && !isLoading) ||
            (fetched && instance?.ext_ref && iframe && !instance?.features?.wizardUrl && !isLoading) */
            fetched && iframe && !instance?.features?.wizardUrl && !isLoading
        ) {
            (async () => {
                await createIntegrationProfile(platform)
                // the tray "finish" workflow url is needed, not built on integration creation, but when it is fetched
                !instance?.features && fetchIntegrations()
            })()
        }
    }, [instance, fetched, isLoading, iframe])


    return (
        <>
            {

                fetched && instance &&
                <ModalContent >
                    <TrayConfigIframe
                        onComplete={() => setConfigCompleted(true)}
                        onCancel={() => cancelIntegrationConfig({
                            iframe: true,
                            platform,
                            skipConfirm: true,
                            fn: () => setConfigCompleted(true),
                        })}
                    />
                </ModalContent>
            }
            {
                fetched && instance &&
                iframe && configCompleted &&
                <ModalActions >
                    {
                        !configCompleted &&
                        <Button onClick={() => cancelIntegrationConfig({
                            iframe: true,
                            platform,
                            skipConfirm: false,
                            fn: () => setConfigCompleted(true),
                        })}>
                            {actionText.discard}
                        </Button>
                    }
                    {
                        configCompleted &&
                        <Button
                            primary
                            onClick={async () => {
                                /* async () => {
                                    finishIntegrationConfig(platform)
                                    await closeModal()
                                    cancelIntegrationConfig(platform)
                                } */
                                finishIntegrationConfig(platform)
                                await closeModal()
                                cancelIntegrationConfig({
                                    iframe: true,
                                    platform,
                                    skipConfirm: true,
                                    fn: () => setConfigCompleted(true),
                                })
                            }}
                        >
                            {actionText.save}
                        </Button>
                    }
                </ModalActions>
            }
        </>
    )
});




